export class Brand {
    constructor(public BID?, public BN?) { }
}